import label, { labelVariants, type LabelVariantsType } from './label';
import logo, { logoVariants, type LogoVariantsType } from './logo';
import textContent, { textContentVariants, type TextContentVariantsType } from './text-content';
import type { Utility } from '../../../types/utility';

export const navVariants = {
  label: labelVariants,
  logo: logoVariants,
  textContent: textContentVariants,
};

const nav = {
  label,
  logo,
  textContent,
};

export type NavComponentsType = 'label' | 'logo' | 'textContent';

export interface NavType {
  /** The Nav subcomponent types. */
  SubComponents: {
    [K in NavComponentsType]: Utility.VariantKeyModes<
      K extends 'logo'
        ? LogoVariantsType
        : K extends 'label'
          ? LabelVariantsType
          : K extends 'textContent'
            ? TextContentVariantsType
            : never
    >;
  };
  /** The Nav Dropdown Heading component types. */
  Label: Utility.VariantKeys<LabelVariantsType>;
  /** The Nav.Logo component types. */
  Logo: Utility.VariantKeys<LogoVariantsType>;
  /** The Nav Dropdown Text Content component types. */
  TextContent: Utility.VariantKeys<TextContentVariantsType>;
}

export default nav;
